<div class="page-content">
  <div class="row">
      <div class="col-lg-12">
          <div class="ibox ">
              <div class="ibox-body">
                  <div class="iboxcontent">
                      <h3>Post Job</h3>
                      <div class="stepsnumber">
                          <span>Steps 2/5</span>
                      </div>
                  </div>
                  <h6 class="heading-6">Pay Options<span class="orangeText">*</span></h6>
                  <form [formGroup]="form" (ngSubmit)="onSubmit()">
                    <div class="customradiobox">
                        <div class="custom_radio">
                            <input type="radio" id="featured-1" name="payOption" formControlName="payOption" value="Range" (change)="selectPayOption($event)"><label for="featured-1">Range</label>
                            <input type="radio" id="featured-2" name="payOption" formControlName="payOption" value="Starting amount"><label for="featured-2">Minimum Pay</label>
                            <input type="radio" id="featured-3" name="payOption" formControlName="payOption" value="Maximum amount"><label for="featured-3">Maximum Pay</label>
                            <input type="radio" id="featured-4" name="payOption" formControlName="payOption" value="Exact amount"><label for="featured-4">Exact amount</label>
                        </div>
                        <div class="text-danger" *ngIf="form.controls['payOption'].hasError('required') && showError">
                            *Please select pay option.
                        </div> 
                    </div>
                    <div class="row">
                        <div class="col-sm-6 col-lg-6 col-md-12" *ngIf="form.value.payOption == 'Range'">
                            <div class=" d-flex justify-content-between align-items-center">
                                <div class="form-group priceValidation">
                                    <label>Minimum</label>
                                    <div class="amount">
                                        <span>$</span>
                                        <input type="input" class="form-control" id="inputDate" placeholder="" formControlName="minimum" (keypress)="preventNumbers($event)" maxlength="8">
                                    </div>
                                    
                                    <div class="text-danger" *ngIf="(form.value.minimum == null || form.value.minimum == 0) && showAmountError">
                                        *Minimum value should be greater then 0.
                                    </div> 
                                    <div class="text-danger" *ngIf="form.value.minimum > form.value.maximum && showAmountLessError">
                                        *Minimum value should not be greater then Maximum.
                                    </div> 
                                </div>
                                <div class="to">TO</div>
                                <div class="form-group priceValidation">
                                    <label> Maximum</label>
                                    <div class="amount">
                                        <span>$</span>
                                        <input type="input" class="form-control" id="inputDate2" placeholder="" formControlName="maximum" (keypress)="preventNumbers($event)" maxlength="8">
                                    </div>
                                    <div class="text-danger" *ngIf="(form.value.maximum == null || form.value.maximum == 0) && showAmountError">
                                        *Please enter the maximum value.
                                    </div> 
                                    <!-- <div class="text-danger" *ngIf="form.value.maximum == 0 && showAmountError">
                                        *Maximum value should be grater then 0.
                                    </div>  -->
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-lg-6 col-md-12" *ngIf="form.value.payOption != 'Range'">
                            <div class="form-group">
                                <label>Amount</label>
                                <div class="amount">
                                    <span>$</span>
                                    <input type="input" class="form-control"  placeholder="Please enter amount" formControlName="price" (keypress)="preventNumbers($event)" maxlength="8">
                                </div>
                                
                                <div class="text-danger" *ngIf="form.value.price == '' && showError">
                                    *Please enter amount.
                                </div>  
                                <div class="text-danger" *ngIf="form.value.price == 0 && showError">
                                    *Amount should be grater then 0.
                                </div>  
                            </div>
                        </div>
                        <div class="col-sm-6 col-lg-6 col-md-12">
                            <div class="form-group">
                                <label>Rate<span class="orangeText">*</span>  </label>
                                <select class="form-control" formControlName="rate">
                                    <option selected disabled [value]=null>Select</option>
                                    <option value="Per hour">Per hour</option>
                                    <option value="Per day">Per day</option>
                                    <option value="Per week">Per week</option>
                                    <option value="Per month">Per month</option>
                                    <option value="Per year">Per year</option>
                                </select>
                                <div class="text-danger" *ngIf="form.controls['rate'].hasError('required') && showError">
                                    *Please select rate.
                                </div> 
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-lg-12 col-md-12">
                            <div class="form-group">
                                <h6 class="heading-6">Benefits </h6>
                                <ul class="suggestedskills">
                                    <li *ngFor="let ben of allBenefits;let i=index;" (click)="selectedBenefits(i,$event)" [ngClass]="ben.selected == true ? 'selected' : ''">{{ben.name}}</li>
                                    <button class="showmore" *ngIf="allBenefits.length > 9">Show 10 more <img src="assets/images/showmore.svg"></button>
                                </ul>
                            </div>
                            <div class="form-group">
                                <h6 class="heading-6">Supplemental pay </h6>
                                <ul class="suggestedskills">
                                    <li *ngFor="let sup of allSupply;let i=index;" (click)="selectedSupply(i,$event)" [ngClass]="sup.selected == true ? 'selected' : ''">{{sup.name}}</li>
                                </ul>
                            </div>
                            <a href="javascript:void(0);" class="planbtn greyBtn" (click)="back()">Back</a> 
                            <input type="submit" value="Continue" class="planbtn fill"/>
                        </div>
                    </div>
                  </form>
              </div>
          </div>



      </div>
  </div>
</div>